import React, { useEffect, useMemo, useState } from "react"
import eye from "../../../assets/images/icons/eye.svg"

import { useLazyGetHelpRequestQuery } from "store/api/user/help.api"
import TableContainer from "components/Common/TableContainer"
import { Button, UncontrolledTooltip } from "reactstrap"
import HelpModelView from "modals/helpModelView"
import { getTableSortingHeaderIcon } from "helpers/common"
import { Link, useLocation, useNavigate } from "react-router-dom"
import HelpModel from "modals/helpModel"
import { useSelector } from "react-redux"

const HelpRequestsSearchResults = ({ data = [], close }) => {
  const [getHelpRes] = useLazyGetHelpRequestQuery()
  const location = useLocation()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const { userType } = useSelector((state) => state.user)

  const truncateString = (str, maxLength = 35) => {
    if (str.length <= maxLength) return str
    return str.slice(0, maxLength) + "..."
  }

  const getStatus = (key) => {
    let status = "Active"
    let className = "Active"

    switch (key) {
      case "OPEN":
        status = "Open"
        className = "under_review"
        break

      default:
        status = "Closed"
        className = "approved"
        break
    }

    return (
      <div className={`badge ${className}`}>
        <span></span> {status}
      </div>
    )
  }

  const columns = useMemo(() => {
    const baseColumns = [
      {
        header: ({ column }) => getTableSortingHeaderIcon(column, "Date"),
        id: "created_at",
        accessorFn: (row) =>
          row?.created_at ? new Date(row.created_at).getTime() : null,
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => row.original.formatted_created_at,
      },
      {
        header: ({ column }) => getTableSortingHeaderIcon(column, "Ticket ID"),
        accessorKey: "unique_code",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Message",
        accessorKey: "message",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => (
          <div className="d-flex justify-content-center align-items-center gap-2">
            <div>
              <div className="table-user-name">
                {truncateString(row?.original?.message)}
              </div>
            </div>
          </div>
        ),
      },
      {
        header: "Status",
        accessorKey: "status",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => (
          <div className="code-status">
            {getStatus(row?.original?.status || row?.original?.status)}
          </div>
        ),
      },

      {
        id: "action",
        header: "Actions",
        cell: ({ row }) => {
          const viewTooltip = `editTooltip-${row?.original?.id}`

          return (
            <div className="d-flex justify-content-center align-items-center gap-3">
              <>
                <div className="action-view">
                  <Link
                    to={`/help/requests?id=${row?.original?.id}`}
                    onClick={close}
                    id={viewTooltip}
                  >
                    <img src={eye} alt="" />
                    <UncontrolledTooltip placement="top" target={viewTooltip}>
                      View
                    </UncontrolledTooltip>
                  </Link>
                </div>
              </>
            </div>
          )
        },
      },
    ]

    return baseColumns
  }, [userType])

  return (
    <>
      <TableContainer
        count={data.length}
        filters={{ page: 1, pageSize: 100 }}
        columns={columns}
        data={data}
        isGlobalFilter={false}
        isCustomPageSize={false}
        isPagination={false}
        pagination="pagination"
        paginationWrapper="dataTables_paginate paging_simple_numbers"
        tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
      />
    </>
  )
}

export default HelpRequestsSearchResults
